import { api } from './client'

export const leaderboardAPI = {
  getLeaderboard: (period = '') => api.get('/leaderboard', { params: period ? { period } : {} }),
  getVendorLeaderboard: () => api.get('/leaderboard/vendors'),
}
